<template>
  <i :class="klass" aria-hidden="true"></i>
</template>

<script>
import 'font-awesome/css/font-awesome.min.css'

export default {
  name: 'fa-icon',
  props: {
    icon: {
      type: String,
      required: true
    },
    animated: {
      type: Boolean,
      default: false
    },
    size: String
  },
  computed: {
    klass () {
      const spin = this.animated ? 'fa-spin' : ''
      return `fa fa-${this.icon} ${spin}`
    }
  }
}
</script>


// WEBPACK FOOTER //
// FaIcon.vue?947822e6